<template>
  <div class="password-wait">
    <div class="password-wait__container">
      <MailIcon />
      <AHeading class="password-wait__heading" :level="2"
        >再設定メールを送信しました</AHeading
      >
      <ABody class="password-wait__body" size="small">
        入力いただいたメールアドレスにパスワード再設定メールを送信しています。
        メールを確認いただき、添付されているURLからパスワードの再設定に進んでください。
      </ABody>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import AHeading from '@/components/atoms/ATypography/AHeading/index.vue';
import ABody from '@/components/atoms/ATypography/ABody/index.vue';
import MailIcon from '@/assets/images/svg/icon/mailIcon.vue';

export default defineComponent({
  name: 'PasswordWait',
  components: {
    MailIcon,
    AHeading,
    ABody
  }
});
</script>

<style lang="scss" scoped>
.password-wait {
  &__container {
    padding-top: 8px;
    text-align: center;
  }
  &__heading {
    margin-top: 24px;
  }
  &__body {
    margin-top: 8px;
  }
}
</style>
